import { createSlice } from '@reduxjs/toolkit'

export const salesAreaSlice = createSlice({
    name: 'salesAreas',
    initialState: {
        salesAreas: [],
    },
    reducers: {
        load: (state, action) => {
            state.salesAreas = action.payload
        },
    }
})
export default salesAreaSlice.reducer

export const { load } = salesAreaSlice.actions

// export const selectRepsStatus = state => state.reps.repsStatus
// export const selectAllReps = state => state.reps.reps
export const getAllAreas = (state) => state.salesAreas.salesAreas || [];
export const getAreaByID = (state, id) => state.salesAreas.salesAreas.find(sa => sa.ID === id);
// export const selectRepByID = (state, repID) => state.reps.reps.find(rep => rep.ID === repID)

